import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "@/lib/LangContext";
import OfferBanner from "@/components/OfferBanner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Chaos from "@/components/Chaos";
import Catalog from "@/components/Catalog";
import Generics from "@/components/Generics";
import HowItWorks from "@/components/HowItWorks";
import Coverage from "@/components/Coverage";
import Trust from "@/components/Trust";
import Support from "@/components/Support";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import PolicyPage from "@/pages/PolicyPage";
import HospitalsPage from "@/pages/HospitalsPage";

const Home = () => (
  <div className="bg-lokam-cream min-h-screen">
    <OfferBanner />
    <Header />
    <main>
      <Hero />
      <Chaos />
      <Catalog />
      <Generics />
      <HowItWorks />
      <Coverage />
      <Trust />
      <Support />
    </main>
    <Footer />
    <FloatingWhatsApp />
  </div>
);

function App() {
  React.useEffect(() => {
    const hideBadge = () => {
      const el = document.getElementById("emergent-badge");
      if (el) {
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
        el.innerHTML = "";
      }
    };
    hideBadge();
    const observer = new MutationObserver(hideBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hospitals" element={<HospitalsPage />} />
          <Route path="/privacy" element={<PolicyPage policyKey="privacy" />} />
          <Route path="/terms" element={<PolicyPage policyKey="terms" />} />
          <Route path="/refund-policy" element={<PolicyPage policyKey="refund" />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
